import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { Link } from '@/modules/perseo-billing/ui/react/src';
import { PdsIcon } from '@/modules/perseo-billing/ui/react/src/components/gamma';

const WHATSAPP_NUMBER = '+56964963826';
const WHATSAPP_LINK = 'https://wa.me/56964963826';

const ChangeEmailInfo = ({ className }: { className: string }) => {
  const { contactByWhatsappGtm } = useGtmBillingProduct();

  return (
    <div
      tabIndex={0}
      className={`co-flex co-items-center co-rounded-8px co-border-1 co-p-8px co-border-pds-information-500 co-bg-pds-information-100 co-gap-x-2 ${className}`}
    >
      <div className="co-flex co-self-start co-p-1 co-flex-shrink-0">
        <PdsIcon
          icon="PdsFilledInfoCircle"
          className="co-fill-pds-information-500"
        />
      </div>
      <p className="co-inline co-text-[14px] co-text-pds-neutral-900 co-leading-[16px]">
        {'Si necesitas '}
        <span className="co-font-semibold">
          {'cambiar el correo asociado a tu cuenta'}
        </span>
        {', comunícate con nosotros a través de Whatsapp '}
        <span className="co-inline-block">
          <Link
            target="_blank"
            underline="always"
            weight="semibold"
            color="pds-information-600"
            onClick={contactByWhatsappGtm}
            href={WHATSAPP_LINK}
            children={WHATSAPP_NUMBER}
          />
        </span>
      </p>
    </div>
  );
};

export default ChangeEmailInfo;
